const numberFormatter = (value: any) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const num = typeof value === 'string' ? Number(value) : value;

  if (isNaN(num)) {
    return '';
  }

  const formatted_value = num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatted_value;
};

const valuteNumberFormatter = (value: any, country: string = 'en-US', currency: string = 'USD', negative: boolean = false) => {
  if (value === undefined || value === null || value === '') return '';

  const num = typeof value === 'string' ? Number(value) : value;

  if (isNaN(num)) return '';

  const safeNum = negative ? num : Math.max(0, num)

  const formatted_currency = safeNum.toLocaleString(country, {
    style: 'currency',
    currency: currency,
  });
  return formatted_currency;
};

const eleminateCurrency = (val: any) => {
  if (val === null || val === undefined) return '';

  return String(val).replace(/\$/g, '').replace(/,/g, '').trim();
};

export { numberFormatter, valuteNumberFormatter, eleminateCurrency };
